import script from "./PrintView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintView.vue?vue&type=script&setup=true&lang=js"

import "./PrintView.vue?vue&type=style&index=0&id=5b8cf408&lang=css"

const __exports__ = script;

export default __exports__